import { Row, Col, Card, Typography, Spin } from "antd";
import { Skeleton, Switch, Avatar } from 'antd';
import Slider from 'react-slick';
import "../Pages/desktop.css";
import React, { useEffect, useState } from "react";
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import moment from "moment";
import { useParams } from "react-router";
const { Meta } = Card;
const { Text, Link } = Typography;




const FixturesDesk = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(true);
    const [fixtures, setFixtures] = useState(null);
    const [complete, setComplete] = useState(null);
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const TodayDate = moment(new Date()).format("DD MMM YYYY, dddd");
    
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 4,
        initialSlide: id

      };
    

        useEffect(() => {
            if(loading == true){
                fetch('https://api.arynews.tv/sports/apiTxt/cricApi.php?q=completeMatches')
                .then(response => response.json())
                .then(data => {
                    setComplete(data);
                    // alert(data);
                    fetch('https://api.arynews.tv/sports/apiTxt/cricApi.php?q=scheduleMatches')
                    .then(response => response.json())
                    .then(data => {
                        setFixtures(data);
                        // alert(data);

                        setTimeout(() => {
                            setLoading(false)
                        }, 3000);
                        
                    });
                });

            
            }
            
        });
    
    return(
        <>
        
      

    
            {loading == false ?
                      
                <div className="mainCards">
                   
           
                
                   <Slider {...settings}>   

                   {complete.data.map(( item, key ) => 
                  
                  (key < 40 ? <Card className="customCardWidth"

                  style={{ width: 250, marginTop: 16 }}
                  
                  title= {item.date_wise}
                  extra={<a class="linkScorecard" target="_blank" href={'https://a-sports.tv/scorecard/?matchid='+item.match_id}> Scorecard </a>} style={{ width: 300 }}
                  >
                 
                  <Row>
                      <Col span={24}>
                         
                          <Meta
                      avatar={
                          <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_a_short.toLowerCase()+'.svg'} />
                          
                      }
                      title={<div>{item.team_a} <span className="resultsChip">{item.team_a_scores}</span></div>}
                      
                      />
                         
                          <Meta
                      avatar={
                          <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_b_short.toLowerCase()+'.svg'} />
                          
                      }
                      title={<div>{item.team_b} <span className="resultsChip">{item.team_b_scores}</span></div>}
                      extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.time}</span>} style={{ width: 300 }}
                      />  
                  
                     
                      </Col>
                      <Col className="statdium" style={{marginTop: 5,color:'black'}} span={24}>
                        <div className="resultFinal">{item.result.replace('wkts','wickets')} </div>

                      </Col>
                  </Row>
                      

                                                  
                
              </Card> : <div></div>)
                   
                       
                     
              )}
              
                    {fixtures.data.map(( item, key ) => 
                  
                    <Card

                            style={{ width: 280, marginTop: 16 }}
                            
                            title= {item.date_wise == TodayDate ? <div><span className="todayMatchChip">Upcoming</span> <span></span></div> : item.date_wise}
                            extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.match_time.replace('30', '00')}</span>} style={{ width: 300 }}
                            >
                           
                            <Row>
                                <Col span={24}>
                                   
                                    <Meta
                                avatar={
                                    <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_a_short.toLowerCase()+'.svg'} />
                                    
                                }
                                title={item.team_a}
                               
                                
                                />
                                   
                                    <Meta
                                avatar={
                                    <Avatar width={50} src={'https://api.arynews.tv/sports/svg/'+item.team_b_short.toLowerCase()+'.svg'} />
                                    
                                }
                                title={item.team_b}
                                extra={<span style={{ color: '#f60000', fontWeight: 'bold' }}>{item.time}</span>} style={{ width: 300 }}
                                />  
                            
                               
                                </Col>
                                <Col className="statdium" style={{marginTop: 5,color:'black'}} span={24}>
                                   <div className="venueChange" >{item.venue}</div>
                                </Col>
                            </Row>
                                

                                                            
                          
                        </Card>
                     
                         
                       
                )}
                
                </Slider>
                </div>
               
                :<div className="centLoading">
                        <Spin size="large" />
                    </div>}
                  
                
        
        </>       
        
    );
}

export default FixturesDesk;